import '../../styles/styles.css';
import { App } from '../../scripts/index';
export default function Charge() {
    App();
}
